class ConditionDetail {
    andOr: string;
    id: number;
    fact: string;
    operator: string;
    value: string;

    constructor() {
        this.andOr = "";
        this.id = 0;
        this.fact = "";
        this.operator = "";
        this.value = "";
    }
}

export default ConditionDetail;